import { render, staticRenderFns } from "./AcompanhamentoTabela.vue?vue&type=template&id=9a87f4b2&scoped=true"
import script from "./AcompanhamentoTabela.vue?vue&type=script&lang=js"
export * from "./AcompanhamentoTabela.vue?vue&type=script&lang=js"
import style0 from "./AcompanhamentoTabela.vue?vue&type=style&index=0&id=9a87f4b2&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a87f4b2",
  null
  
)

export default component.exports